<template>
  <div>
    <div style="width:400px;margin:0 auto;margin-top:30px;padding-top:10px">
      <v-text-field
        type="number"
        style="min-width:300px;width:400px;margin:0 auto;height:60px"
        label="Phone Number"
        v-model="phone"
        solo
      />
      <div style="width:100%;float:left">
        <v-btn
          color="primary"
          style="min-width:300px;width:400px;margin:0 auto;"
          @click="validate"
        >Submit</v-btn>
      </div>
    </div>
    <v-dialog v-model="registerdialog" width="350" height="300">
      <v-card>
        <v-card-title>Enter Detail</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field
            type="text"
            style="width:300px;margin:0 auto;height:60px;"
            label="Enter First Name"
            v-model="firstname"
            solo
          />
          <v-text-field
            type="text"
            style="width:300px;margin:0 auto;height:60px;"
            label="Enter Middle Name"
            v-model="middlename"
            solo
          />
          <v-text-field
            type="text"
            style="width:300px;margin:0 auto;height:60px;"
            label="Enter Last Name"
            v-model="lastname"
            solo
          />
          <v-btn color="primary" @click="register" style="width:300px;margin-left:10px">Validate</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="otpcheck" persistent width="300" height="300">
      <v-card>
        <v-card-title>Enter OTP</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-text-field
            type="number"
            style="width:200px;margin:0 auto;height:60px;"
            label="OTP"
            v-model="otp"
            solo
          />
          <v-btn color="primary" @click="verify" style="width:200px;margin-left:35px">Submit</v-btn>
          <v-btn color="primary" @click="resend" style="width:200px;margin-left:35px">Resend OTP</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <Loader v-if="loader"></Loader>
  </div>
</template>
<script>
import Loader from "../components/Loader";
export default {
  data() {
    return {
      phone: "",
      loader: false,
      firstname: "",
      middlename: "",
      lastname: "",
      registerdialog: false,
      otpcheck: false,
      otp: ""
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    security() {
      return this.$store.getters.security;
    },
    dmr() {
      return this.$store.getters.dmr;
    }
  },
  watch: {
    dmr() {
      console.log(this.dmr);
    }
  },
  methods: {
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type
      });
    },
    register() {
      let vm = this;
      if (vm.phone === "")
        return vm.notification("error", "Phone Number Required");
      if (vm.phone.length !== 10)
        return vm.notification("error", "10 Digit Number Required");
      if (vm.firstname === "")
        return vm.notification("error", "First Required");
      if (vm.middlename === "")
        return vm.notification("error", "Middle Name Required");
      if (vm.lastname === "")
        return vm.notification("error", "Last Name Required");
      let doc = {
        Sender_MobileNo: vm.phone,
        First_Name: vm.firstname,
        Middle_Name: vm.middlename,
        Last_Name: vm.lastname,
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Security_Key: vm.security,
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "RegisterUser",
          data: doc
        })
        .then(function(res) {
          vm.loader = false;
          let data = res.data;
          if (data.STATUS === "SUCCESS") {
            vm.registerdialog = false;
            vm.otpcheck = true;
            vm.notification("success", data.MESSAGE);
            return;
          }
          vm.notification("error", data.MESSAGE);
        })
        .catch(function(err) {
          vm.loader = false;
          vm.notification("error", err.message);
        });
    },
    validate() {
      let vm = this;
      if (vm.user == null || !vm.user.phone)
        return vm.notification("error", "Login Required!");
      if (vm.phone === "")
        return vm.notification("error", "Phone Number Required");
      if (vm.phone.length !== 10)
        return vm.notification("error", "10 Digit Number Required");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Security_Key: vm.security,
        Sender_MobileNo: vm.phone
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "CheckUser",
          data: doc
        })
        .then(function(res) {
          vm.loader = false;
          let data = res.data;
          if (data.STATUS === "SUCCESS") {
            vm.notification("success", data.MESSAGE);
            let doc = data.request;
            doc.name = data.CUSTOMERNAME;
            vm.$store.commit("setdmr", doc);
            return;
          }
          if (data.MESSAGE === "Entered Mobile Number is not Registered.") {
            vm.registerdialog = true;
          }
          if (data.MESSAGE === "Customers OTP validation PENDING") {
            vm.otpcheck = true;
          }
          vm.notification("error", data.MESSAGE);
        })
        .catch(function(err) {
          vm.loader = false;
          vm.notification("error", err.message);
        });
    },
    resend() {
      let vm = this;
      if (vm.phone === "")
        return vm.notification("error", "Phone Number Required");
      if (vm.phone.length !== 10)
        return vm.notification("error", "10 Digit Number Required");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Security_Key: vm.security,
        Sender_MobileNo: vm.phone
     };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Resend_Register_Otp",
          data: doc
        })
        .then(function(res) {
          vm.loader = false;
          let data = res.data;
          if (data.STATUS === "SUCCESS") {
            vm.notification("success", data.MESSAGE);
            return;
          }
          if (data.STATUS === "FAILED") {
            vm.notification("success", "Try after sometime");
            return;
          }
          vm.notification("error", data.MESSAGE);
        })
        .catch(function(err) {
          vm.loader = false;
          vm.notification("error", err.message);
        });
    },
    verify() {
      let vm = this;
      if (vm.otp === "") return vm.notification("error", "OTP Required");
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        AuthKey: vm.user.authkey,
        Source: "json",
        Security_Key: vm.security,
        Sender_MobileNo: vm.phone,
        OTP: vm.otp
      };
      vm.loader = true;
      vm.$store
        .dispatch("axiosdmrpost", {
          url: "Register_Otp_Validate",
          data: doc
        })
        .then(function(res) {
          vm.loader = false;
          let data = res.data;
          if (data.STATUS === "SUCCESS") {
            vm.notification("success", data.MESSAGE);
            let doc = data.request;
            doc.name = data.CUSTOMERNAME;
            vm.$store.commit("setdmr", doc);
            return;
          }
          if (data.MESSAGE === "Entered Mobile Number is not Registered.") {
            vm.registerdialog = true;
          }
          if (data.MESSAGE === "Customers OTP validation PENDING") {
          }
          vm.notification("error", data.MESSAGE);
        })
        .catch(function(err) {
          vm.loader = false;
          vm.notification("error", err.message);
        });
    }
  },
  components: { Loader }
};
</script>